export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13466.d931f3ec.jpg";